var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tppDateItemList" }, [
    _vm.homeType === "salesLeader_home"
      ? _c("div", [
          _vm.type === "sales"
            ? _c("div", [
                _c("div", { staticClass: "line-one flex" }, [
                  _c("div", { staticClass: "tppDateItem" }, [
                    _c("div", { staticClass: "txt" }, [
                      _vm._v(
                        _vm._s(
                          _vm.from === "more"
                            ? _vm.$t("dashboard.salesNumber")
                            : _vm.$t("dashboard.ECharts_actual")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "nums",
                        on: { click: _vm.actualCountDetail },
                      },
                      [
                        _c("span", { staticClass: "num1 blue" }, [
                          _vm._v(
                            _vm._s(
                              _vm.paddingNum(_vm.sourceData.actualCount) == 0
                                ? "-"
                                : _vm.paddingNum(_vm.sourceData.actualCount)
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tppDateItem" }, [
                    _c("div", { staticClass: "txt" }, [_vm._v("AOP")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "nums" }, [
                      _c("span", { staticClass: "num1" }, [
                        _vm._v(
                          _vm._s(
                            _vm.paddingNum(_vm.sourceData.aopCount) == 0
                              ? "-"
                              : _vm.paddingNum(_vm.sourceData.aopCount)
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tppDateItem" }, [
                    _c("div", { staticClass: "txt" }, [_vm._v("SOP")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "nums" }, [
                      _c("span", { staticClass: "num1" }, [
                        _vm._v(
                          _vm._s(
                            _vm.paddingNum(_vm.sourceData.sopCount) == 0
                              ? "-"
                              : _vm.paddingNum(_vm.sourceData.sopCount)
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "line" }),
                _vm._v(" "),
                _c("div", { staticClass: "line-two flex" }, [
                  _c("div", { staticClass: "tppDateItem" }, [
                    _c("div", { staticClass: "txt" }, [
                      _vm._v(
                        "AOP " + _vm._s(_vm.$t("dashboard.achievementRate"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "nums" }, [
                      _c(
                        "span",
                        {
                          staticClass: "num1",
                          style: "color: " + _vm.sourceData.color + ";",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              parseFloat(_vm.sourceData.aopCount) === 0
                                ? "-"
                                : _vm.paddingNum(_vm.sourceData.finishRate)
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.sourceData.finishRate != undefined
                        ? _c("span", { staticClass: "num2" }, [_vm._v("%")])
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tppDateItem" }, [
                    _c("div", { staticClass: "txt" }, [
                      _vm._v(
                        "AOP " + _vm._s(_vm.$t("dashboard.underachievedQuat"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "nums" }, [
                      _c("span", { staticClass: "num1" }, [
                        _vm._v(_vm._s(_vm.paddingNum(_vm.sourceData.gapCount))),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            : _c("div", [
                _c("div", { staticClass: "line-one flex" }, [
                  _c("div", { staticClass: "tppDateItem" }, [
                    _c("div", { staticClass: "txt" }, [
                      _vm._v(
                        _vm._s(
                          _vm.from === "more"
                            ? _vm.$t("dashboard.salesNumber")
                            : _vm.$t("dashboard.ECharts_actual")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "nums",
                        on: { click: _vm.actualCountDetail },
                      },
                      [
                        _c("span", { staticClass: "num1 blue" }, [
                          _vm._v(
                            _vm._s(_vm.paddingNum(_vm.sourceData.actualCount))
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tppDateItem" }, [
                    _c("div", { staticClass: "txt" }, [_vm._v("AOP")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "nums" }, [
                      _c("span", { staticClass: "num1" }, [
                        _vm._v(_vm._s(_vm.paddingNum(_vm.sourceData.aopCount))),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tppDateItem" }, [
                    _c("div", { staticClass: "txt" }, [
                      _vm._v(
                        "AOP " + _vm._s(_vm.$t("dashboard.underachievedQuat"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "nums" }, [
                      _c("span", { staticClass: "num1" }, [
                        _vm._v(_vm._s(_vm.paddingNum(_vm.sourceData.gapCount))),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "line" }),
                _vm._v(" "),
                _c("div", { staticClass: "line-two flex" }, [
                  _c("div", { staticClass: "tppDateItem" }, [
                    _c("div", { staticClass: "txt" }, [
                      _vm._v(
                        "AOP " + _vm._s(_vm.$t("dashboard.achievementRate"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "nums" }, [
                      _c(
                        "span",
                        {
                          staticClass: "num1",
                          style: "color: " + _vm.sourceData.color + ";",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              parseFloat(_vm.sourceData.aopCount) === 0
                                ? "-"
                                : _vm.paddingNum(_vm.sourceData.finishRate)
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.sourceData.finishRate != undefined
                        ? _c("span", { staticClass: "num2" }, [_vm._v("%")])
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tppDateItem" }, [
                    _c("div", { staticClass: "txt" }, [_vm._v("SOP")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "nums" }, [
                      _c("span", { staticClass: "num1" }, [
                        _vm._v(_vm._s(_vm.paddingNum(_vm.sourceData.sopCount))),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
        ])
      : _c("div", [
          _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "tppDateItem" }, [
              _c("div", { staticClass: "txt" }, [
                _vm._v(
                  _vm._s(
                    _vm.from === "more"
                      ? _vm.$t("dashboard.salesNumber")
                      : _vm.$t("dashboard.ECharts_actual")
                  ) + " / AOP"
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "nums" }, [
                _c("span", { staticClass: "num1 blue" }, [
                  _vm._v(
                    _vm._s(
                      _vm.paddingNum(_vm.sourceData.actualCount) == 0
                        ? "-"
                        : _vm.paddingNum(_vm.sourceData.actualCount)
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "num2" }, [
                  _vm._v(
                    "/" +
                      _vm._s(
                        _vm.paddingNum(_vm.sourceData.aopCount) == 0
                          ? "-"
                          : _vm.paddingNum(_vm.sourceData.aopCount)
                      )
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "line" }),
          _vm._v(" "),
          _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "tppDateItem" }, [
              _c("div", { staticClass: "txt" }, [
                _vm._v(_vm._s(_vm.$t("dashboard.achievementRate"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "nums" }, [
                _c("span", { staticClass: "num1" }, [
                  _vm._v(
                    _vm._s(
                      parseFloat(_vm.sourceData.aopCount) == 0
                        ? "-"
                        : _vm.paddingNum(_vm.sourceData.finishRate)
                    )
                  ),
                ]),
                _vm._v(" "),
                _vm.sourceData.finishRate != undefined
                  ? _c("span", { staticClass: "num2" }, [_vm._v("%")])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tppDateItem" }, [
              _c("div", { staticClass: "txt" }, [
                _vm._v(_vm._s(_vm.$t("dashboard.underachievedQuat"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "nums" }, [
                _c("span", { staticClass: "num1" }, [
                  _vm._v(
                    _vm._s(
                      _vm.paddingNum(_vm.sourceData.aopCount) == 0
                        ? "-"
                        : _vm.paddingNum(_vm.sourceData.gapCount)
                    )
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }